export const createActionTypes = (base) => {
  return {
    REQUEST: `${base}`,
    SUCCESS: `${base}.SUCCESS`,
    FAIL: `${base}.FAIL`,
    ERROR: `${base}.ERROR`,
  };
};
